module.exports = __webpack_public_path__ + "img/img-led-guide-LCL.469a9182.jpg";